export const ConfigureOptions  = {
    Model : "Model" ,
    ModelLayeredMedia : "Model - Layered Media",

    //AssignOptions is now controlled by the Import.
    //AssignOptions : "Assign Sections to Group",
    Options : "Sections",
    ConfigureChoices : "Options",
    ChoiceMedia : "Option Media"
} 